import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Root, QrType, ChangeColour, ColourType } from './types';


const initState: Root = {
    qrData: {
        type: QrType.URL,
        qrText: "",
        logoSrc: "",
        qrColour: "#000",
        bgColour: "#fff"
    }
}

export const mainSlice = createSlice({
  name: 'mainReducers',
  initialState: initState,
  reducers: {
    updateQrColour(state, action: PayloadAction<ChangeColour>){
        if(action.payload.colourType === ColourType.QRCOLOUR){
            state.qrData.qrColour = action.payload.colourValue;
        }
        if(action.payload.colourType === ColourType.BGCOLOUR){
            state.qrData.bgColour = action.payload.colourValue;
        }
    },
    updateQrType(state, action: PayloadAction<QrType>){
        state.qrData.type = action.payload;
        state.qrData.qrText = "";
    },
    updateQrText(state, action: PayloadAction<string>){
        //TODO: Parse based on type
        state.qrData.qrText = action.payload
    },
    updateQrLogo(state, action: PayloadAction<string>){
        //This is base64
        state.qrData.logoSrc = action.payload
    }
  },
})

export const { updateQrColour, updateQrType, updateQrText, updateQrLogo } = mainSlice.actions

export default mainSlice;